import { useCallback, useEffect, useState } from 'react';
import './App.css';

import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';

import { AnimatePresence } from 'framer-motion';

import { PublicRoutes } from './routes';
import ScrollToTop from './Utils/common';
import Preloader from './Components/Preloader/preloader.jsx';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // Prevent browser from restoring an old scroll position on refresh
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Start every fresh reload from the top
    window.scrollTo(0, 0);
  }, []);

  // Lock scrolling while the loading screen is visible
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      // Restore scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      // Ensure the page stays exactly at the top
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isLoading]);

  const handleLoadingComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <Router>
      <ScrollToTop />

      {/* APCCI Loading Screen */}
      <AnimatePresence>
        {isLoading && (
          <Preloader
            key="apcci-preloader"
            onLoadingComplete={handleLoadingComplete}
          />
        )}
      </AnimatePresence>

      {/* Main Website */}
      <div
        style={{
          opacity: isLoading ? 0 : 1,
          pointerEvents: isLoading ? 'none' : 'auto',
          transition: 'opacity 0.5s ease'
        }}
      >
        <Routes>
          {PublicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            />
          ))}
        </Routes>
      </div>
    </Router>
  );
}

export default App;